const AllJobPost = () => import("./views/AllJobPost.vue");
const CreateJobPost = () => import("./views/CreateJobPost.vue");
const ViewJobPost = () => import("./views/ViewJobPost.vue");
const ArchivedJobPost = () => import("./views/ArchivedJobPost.vue");
const EditJobPost = () => import("./views/EditJobPost.vue");
const Settings = () => import("./views/Settings.vue");
const AllJobBoards = () => import("./views/AllJobBoards.vue");
const CreateManageJobPosting = () =>
  import("./views/CreateManageJobPosting.vue");
const EditManageJobPosting = () => import("./views/EditManageJobPosting.vue");

export default [
  {
    path: "job-post-request",
    component: AllJobPost,
  },
  {
    path: "job-post-request/archive",
    component: ArchivedJobPost,
  },
  {
    path: "job-post-request/create",
    component: CreateJobPost,
  },
  {
    path: "job-post-request/view/:id",
    component: ViewJobPost,
  },
  {
    path: "job-post-request/edit/:id",
    component: EditJobPost,
  },
  {
    path: "settings",
    component: Settings,
  },
  {
    path: "manage-job-posting-settings",
    component: AllJobBoards,
  },
  {
    path: "manage-job-posting-settings/create",
    component: CreateManageJobPosting,
  },
  {
    path: "manage-job-posting-settings/edit/:id",
    component: EditManageJobPosting,
  },
];
